import { createCustomAction } from 'typesafe-actions';

const UPDATE_ITEM_NAME_EDITOR_VALUE = '@canvas/UPDATE_ITEM_NAME_EDITOR_VALUE';
const OPEN_ITEM_NAME_EDITOR = '@canvas/OPEN_ITEM_NAME_EDITOR';
const CLOSE_ITEM_NAME_EDITOR = '@canvas/CLOSE_ITEM_NAME_EDITOR';

export const updateItemNameEditorValue = createCustomAction(UPDATE_ITEM_NAME_EDITOR_VALUE, type => {
    return (editorId: string, value: string) => ({ type, editorId, value });
});

export const openItemNameEditor = createCustomAction(OPEN_ITEM_NAME_EDITOR, type => {
    return (editorId: string, value: string) => ({ type, editorId, value });
});

export const closeItemNameEditor = createCustomAction(CLOSE_ITEM_NAME_EDITOR, type => {
    return (editorId: string) => ({ type, editorId });
});

export type ItemNameEditorAction =
    | ReturnType<typeof updateItemNameEditorValue>
    | ReturnType<typeof openItemNameEditor>
    | ReturnType<typeof closeItemNameEditor>;
